/**
 * SAFE+ brand metadata + asset references (ADR 115 §7).
 *
 * Wire-format brand-key: `safe-plus`
 * User-visible display string: `SAFE+`
 * Deep-link URL scheme (registered with iOS/Android — DO NOT change): `safeplus://`
 *
 * Per ADR 115 §2, these three strings are intentionally distinct. The
 * brand-key drives internal routing and config; the display string is
 * what users see; the deep-link scheme is sacrosanct (renaming it
 * requires a mobile-binary release).
 *
 * Logo files are imported as URL strings — Vite/Rolldown resolves them
 * at build time. Consumers reference them via `<img src={assets.logoUrl} />`
 * the same way they would any other asset import.
 */

import logoUrl from './logo.png';
import logoDarkUrl from './logo-dark.png';
import faviconUrl from './favicon.ico';

export interface BrandAssets {
  readonly displayName: string;
  readonly logoUrl: string;
  readonly logoDarkUrl: string;
  readonly faviconUrl: string;
}

export const SAFE_PLUS_ASSETS: BrandAssets = Object.freeze({
  displayName: 'SAFE+',
  logoUrl,
  logoDarkUrl,
  faviconUrl,
});

export default SAFE_PLUS_ASSETS;
